import { render, staticRenderFns } from "./notificationPanel.vue?vue&type=template&id=d8abd8ea&scoped=true&"
import script from "./notificationPanel.vue?vue&type=script&lang=js&"
export * from "./notificationPanel.vue?vue&type=script&lang=js&"
import style0 from "./notificationPanel.vue?vue&type=style&index=0&id=d8abd8ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8abd8ea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBadge,VBtn,VFlex,VIcon,VList,VMenu})
